const VOWEL_REGEX = /^[aeiou]/i;

export const getIndefiniteArticle = (value?: string) => {
  const specialization = value?.trim();

  if (!specialization) return '';

  return VOWEL_REGEX.test(specialization) ? 'an' : 'a';
};

export const addIndefiniteArticle = (value?: string) => {
  const specialization = value?.trim();
  const article = getIndefiniteArticle(specialization);

  return article ? `${article} ${specialization}` : '';
};
